const ContractStatusEnum = {
  BOOK: 1,
  DEPOSIT: 2,
  CONTRACT: 3,
  END_CONTRACT: 4
}
export default ContractStatusEnum


// WEBPACK FOOTER //
// ./src/enum/contractStatusEnum.js